module.exports = __webpack_public_path__ + "img/RJC_LP_head@2x.9b91a49.webp";